import styled from 'styled-components'
import {Link, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {useCookies} from 'react-cookie'
import Checkbox from "../../components/common/Checkbox";
import {findIdParams, findIdResult, findPasswordParams, loginParams, tokenResultAtom} from "./entity/Common";
import {login} from "../../services/auth/AuthAxios";
import {atom, useAtom, useSetAtom} from "jotai";
import {modalController} from "../../store";
import {useForm} from "react-hook-form";
import {RowSpan, TextMainColor, ValidationScript} from "../../assets/GlobalStyles";
import {toast} from "react-toastify";
import {selChangePassword, selFindUserId} from "../../services/Platform/ManageUserAxios";
import {ComponentModalFindId, ComponentModalFindPassword} from "../../components/modal";
import {HorizontalRule} from "../../components/common/Common";
import {logo, logo_inline_w} from "../../constants/GlobalConst";

export const FindIdResultAtom = atom(findIdResult)

function FindPassword(props) {
  const [findPasswordInfo, setFindPasswordInfo] = useState(findPasswordParams)
  const {register, handleSubmit, formState: {errors}} = useForm()
  const navigate = useNavigate()
  const handleFindPassword = () => {
    //axios 로 호출하여 서버쪽에서 이메일쪽으로 전송
    selChangePassword(findPasswordInfo).then(response => {
      console.log(findPasswordInfo)
      if (response) {
        //성공
        props.openModal(findPasswordInfo)
      } else {
        toast.warning('입력하신정보가 회원정보와 일치 하지 않습니다')
      }
    })
  }
  /**
   * 담당자 이메일
   * @param event
   */
  const handleManagerEmail = (event) => {
    setFindPasswordInfo({
      ...findPasswordInfo,
      email: event.target.value
    })
  }
  /**
   * 담당자 연락처
   * @param event
   */
  const handleManagerPhone = (event) => {
    setFindPasswordInfo({
      ...findPasswordInfo,
      phone: event.target.value
    })
  }
  /**
   * 담당자 아이디
   * @param event
   */
  const handleMemberId = (event) => {
    setFindPasswordInfo({
      ...findPasswordInfo,
      username: event.target.value
    })
  }

  const onSubmit = (data) => {
    handleFindPassword()
  }

  const onError = () => console.log(errors)

  return (
    <LoginInputComponent>
      <Title>
        <h1>비밀번호 찾기</h1>
      </Title>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <InputGroup>
          <LabelInline>
            <span>아이디</span>
          </LabelInline>
          <div>
            <input type={'text'}
                   placeholder={'아이디를 입력 해주세요'}
                   value={findPasswordInfo.username || ""}
                   {...register('username', {
                     required: "아이디를 입력 해주세요",
                     onChange: (e) => handleMemberId(e)
                   })}
            />
          </div>
          {errors.username && <ValidationScript>{errors.username.message}</ValidationScript>}
        </InputGroup>
        <InputGroup>
          <LabelInline>
            <span>담당자 연락처</span>
          </LabelInline>
          <FindCorporationNo>
            <input type={'text'}
                   placeholder={'연락처를 입력해주세요'}
                   value={findPasswordInfo.phone || ""}
                   {...register('phone', {
                     required: "연락처를 입력해주세요,",
                     onChange: (e) => handleManagerPhone(e)
                   })}
            />
          </FindCorporationNo>
          {errors.phone && <ValidationScript>{errors.phone.message}</ValidationScript>}
        </InputGroup>
        <InputGroup>
          <LabelInline>
            <span>담당자 이메일</span>
          </LabelInline>
          <div>
            <input type={'text'}
                   placeholder={'담당자 이메일을 입력해주세요.'}
                   value={findPasswordInfo.email || ""}
                   onChange={(e) => handleManagerEmail(e)}
                   {...register('email', {
                     required: "이메일을 입력해주세요,",
                     pattern: {
                       value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                       message: "이메일 형식을 확인해주세요"
                     },
                     onChange: (e) => handleManagerEmail(e)
                   })}
            />
          </div>
          {errors.email && <ValidationScript>{errors.email.message}</ValidationScript>}
        </InputGroup>
        <FindGroup/>
        <InputGroup style={{display: 'flex', justifyContent: 'space-between', gap: 5}}>
          <Button type={'submit'}>
            비밀번호 찾기
          </Button>
          <Button type={'button'} onClick={() => navigate('/')}>
            로그인
          </Button>
        </InputGroup>
      </form>
    </LoginInputComponent>
  )
}

function FindId(props) {
  const [findIdInfo, setFindIdInfo] = useState(findIdParams)
  const [, setFindIdResult] = useAtom(FindIdResultAtom)
  const {register, handleSubmit, formState: {errors}} = useForm()
  const success = true
  const navigate = useNavigate()
  const handleFindId = () => {
    if (success) {
      selFindUserId(findIdInfo).then(response => {
          if (response.length !== 0) {
            setFindIdResult(response);
            props.openModal();
          } else {
            toast.info('등록된 아이디나 이메일이 없습니다.')
          }
      })
    } else {
      toast.info('등록된 아이디나 이메일이 없습니다.')
    }
  }

  /**
   * 담당자 이메일
   * @param event
   */
  const handleManagerEmail = (event) => {
    setFindIdInfo({
      ...findIdInfo,
      email: event.target.value
    })
  }
  /**
   * 담당자 연락처
   * @param event
   */
  const handleManagerPhone = (event) => {
    setFindIdInfo({
      ...findIdInfo,
      phone: event.target.value
    })
  }
  const onSubmit = (data) => {
    handleFindId()
  }

  const onError = () => console.log(errors)

  return (
    <LoginInputComponent>
      <Title>
        <h1>아이디 찾기</h1>
      </Title>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <InputGroup>
          <LabelInline>
            <span>담당자 연락처</span>
          </LabelInline>
          <FindCorporationNo>
            <input type={'text'}
                   placeholder={'연락처를 입력해주세요'}
                   value={findIdInfo.phone}
                   {...register('phone', {
                     required: "연락처를 입력해주세요",
                     onChange: (e) => handleManagerPhone(e)
                   })}
            />
          </FindCorporationNo>
          {errors.phone && <ValidationScript>{errors.phone.message}</ValidationScript>}
        </InputGroup>
        <InputGroup>
          <LabelInline>
            <span>담당자 이메일</span>
          </LabelInline>
          <div>
            <input type={'text'}
                   placeholder={'담당자 이메일을 입력해주세요.'}
                   value={findIdInfo.email}
                   {...register('email', {
                     required: "담당자 이메일을 입력해주세요",
                     pattern: {
                       value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                       message: "이메일 형식을 확인해주세요"
                     },
                     onChange: (e) => handleManagerEmail(e)
                   })}
            />
          </div>
          {errors.email && <ValidationScript>{errors.email.message}</ValidationScript>}
        </InputGroup>
        <FindGroup/>
        <InputGroup style={{display: 'flex', justifyContent: 'space-between', gap: 5}}>
          <Button type={'submit'}>
            아이디 찾기
          </Button>
          <Button type={'button'} onClick={() => navigate('/')}>
            로그인
          </Button>
        </InputGroup>
      </form>
    </LoginInputComponent>
  )
}

function LoginComponent() {
  const [loginParamsValue, setLoginParams] = useState(loginParams);
  const [isRemember, setIsRemember] = useState(false)
  const [cookies, setCookie, removeCookie] = useCookies(['rememberAdverId'])
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate();
  const setTokenResult = useSetAtom(tokenResultAtom)
  const {register, setValue, handleSubmit, formState: {errors}} = useForm()

  /**
   * 사용자 아이디 입력
   * @param event
   */
  const handleChangeId = (event) => {
    setLoginParams({
      ...loginParamsValue,
      username: event.target.value
    })
    setValue('username', event.target.value)
    if (isRemember) {
      setCookie('rememberAdverId', event.target.value)
    }
  }
  /**
   * 사용자 패스원드
   * @param event
   */
  const handleChangePassword = (event) => {
    setLoginParams({
      ...loginParamsValue,
      password: event.target.value
    })
  }

  /**
   * 아이디 저장 Cookie 이용
   * @param event
   */
  const handleChangeRemember = (event) => {
    console.log(loginParamsValue.username)
    setIsRemember(event.target.checked)
    if (event.target.checked) {
      setCookie('rememberAdverId', loginParamsValue.username)
    } else {
      removeCookie('rememberAdverId')
    }
  }

  /**
   * 쿠키에 아이디 저장 삭제
   */
  useEffect(() => {
    if (cookies.rememberAdverId !== undefined) {
      setLoginParams({
        ...loginParamsValue,
        username: cookies.rememberAdverId
      })
      setValue('username', cookies.rememberAdverId)
      setIsRemember(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /**
   * 로그인
   * id: uuid,
   * name: 회사명
   * role: 권한며으
   * token
   * username: 로그인 아이디
   */
  const onSubmit = () => {
    login(loginParamsValue).then(response => {
      if (response) {
        if (response === 'disabled') {
          toast.warning('로그인이 제한된 사용자입니다. 담당자에게 문의해주세요.')
        } else {
          setTokenResult({
            id: response.id,
            username: response.username,
            role: response.role,
            name: response.name,
            accessToken: response.token.accessToken,
            refreshToken: response.token.refreshToken
          });
          navigate('/board/dashboard');
        }
      } else {
        toast.info('아이디와 비밀번호를 확인해 주세요.')
      }
    });
  }
  const onError = (error) => console.log(error)

  return (
    <LoginInputComponent>
      <Title>
        <h1><BlockLogo/></h1>
      </Title>
      <RowSpan style={{justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
        <TextMainColor>사용자 로그인</TextMainColor>
        <HorizontalRule/>
        <Link to={'/adminLogin'}>관리자로그인</Link>
      </RowSpan>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <InputGroup>
          <LabelInline>
            <span>아이디</span>
            <Checkbox
              onChange={handleChangeRemember}
              isChecked={isRemember}
              label={'아이디 저장'}
              type={'a'}/>
          </LabelInline>
          <div>
            <input
              type={'text'}
              placeholder={'유저 아이디'}
              maxLength={20}
              value={loginParamsValue.username || ''}
              {...register('username', {
                required: "아이디를 입력해주세요.",
                pattern: {
                  value: /^[a-z]+[a-z0-9-_]{3,19}$/g,
                  message: "아이디는 3자리 이상 영문,숫자,특문(-, _)"
                },
                onChange: (e) => {
                  handleChangeId(e)
                }
              })}/>
          </div>
          {errors.username && <ValidationScript>{errors.username.message}</ValidationScript>}
        </InputGroup>
        <InputGroup>
          <LabelInline>
            <span>비밀번호</span>
          </LabelInline>
          <div style={{position: 'relative'}}>
            <input
              type={!showPassword ? 'password' : 'text'}
              placeholder={'비밀번호(8~12자)'}
              maxLength={16}
              value={loginParamsValue.password || ''}
              {...register("password", {
                required: "비밀번호를 입력해주세요",
                pattern: {
                  value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{8,20}$/,
                  message: "비밀번호를 확인해주세요. 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)"
                },
                onChange: handleChangePassword
              })}/>
            <ShowPassword
              style={showPassword ? {backgroundImage: "url('/assets/images/login/hide.png')"} : {backgroundImage: "url('/assets/images/login/show.png')"}}
              onClick={() => setShowPassword(!showPassword)}/>
          </div>
          {errors.password && <ValidationScript>{errors.password?.message}</ValidationScript>}
        </InputGroup>
        <FindGroup>
          <Link to={'/findId'}>아이디찾기</Link>
          <HorizontalRule/>
          <Link to={'/findPassword'}>비밀번호 찾기</Link>
          <HorizontalRule/>
          <Link to={'/signUp'}>회원가입</Link>
        </FindGroup>
        <InputGroup>
          <Button type={'submit'}>
            로그인
          </Button>
        </InputGroup>
      </form>
    </LoginInputComponent>
  )
}

function Login(props) {
  const setModal = useSetAtom(modalController)
  const handleModalFindId = () => {
    setModal({
      isShow: true,
      width: 500,
      modalComponent: () => {
        return <ComponentModalFindId/>
      }
    })
  }

  const handleModalFindPassword = (passwordParams) => {
    setModal({
      isShow: true,
      width: 500,
      modalComponent: () => {
        return <ComponentModalFindPassword params={passwordParams}/>
      }
    })
  }
  const LoginText = () => {
    if (props.match === 'findId' || props.match === 'findPassword') {
      return <>
        <div>{props.match === 'findPassword' ? "비밀번호" : "아이디"} 찾기가 불가한 회원님들께서는</div>
        <div>고객센터로 연락 주시기 바랍니다.</div>
      </>
    } else {
      return <>
        <div>로그인 하시면 Oaple의</div>
        <div>다양한 서비스를 이용하실 수 있습니다.</div>
      </>
    }
  }
  return (
    <>
      <LoginContainer>
        <div>
          <div>
            <LoginLogo/>
            <div>
              <LoginText/>
              {/*{location.pathname === '/findid' && location.pathname === '/findpassword'?*/}
              {/*  <>*/}
              {/*    <div>{location.pathname === '/findpassword' ? "비밀번호" : "아이디"} 찾기가 불가한 회원님들께서는</div>*/}
              {/*    <div>고객센터(070-1234-1234)로 연락 주시기 바랍니다.</div>*/}
              {/*  </>*/}
              {/*  :*/}
              {/*  <>*/}
              {/*    <div>로그인 하시면 AdPilot의</div>*/}
              {/*    <div>다양한 서비스를 이용하실 수 있습니다.</div>*/}
              {/*  </>*/}
              {/*}*/}
            </div>
          </div>
        </div>
        <div>
          {props.match === 'findId' &&
            <FindId openModal={() => handleModalFindId()}/>
          }
          {props.match === 'findPassword' &&
            <FindPassword openModal={(e) => handleModalFindPassword(e)}/>
          }
          {props.match === 'login' &&
            <LoginComponent/>
          }
        </div>
      </LoginContainer>

    </>
  )
}

export default Login

const LoginContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f5f6f8;

  & > div:first-child {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48%;
    min-height: 100vh;
    overflow: hidden;
    background:
        radial-gradient(circle at 18% 18%, rgba(255,255,255,.16) 0 80px, transparent 81px),
        radial-gradient(circle at 82% 78%, rgba(255,255,255,.1) 0 150px, transparent 151px),
        linear-gradient(rgb(32, 36, 43) 0%, rgb(25, 28, 34) 100%);
    text-align: center;

    &::after {
      position: absolute;
      right: -90px;
      bottom: -110px;
      width: 330px;
      height: 330px;
      border: 1px solid rgba(255,255,255,.16);
      border-radius: 50%;
      content: "";
    }

    & > div {
      position: relative;
      z-index: 1;
    }

    & div > div:last-child {
      margin-top: 14px;

      & div {
        color: rgba(255,255,255,.9);
        font-size: var(--font-size-14);
        line-height: 1.7;
      }
    }
  }

  & > div:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52%;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 34px;
  }

  @media (max-width: 860px) {
    & > div:first-child {
      display: none;
    }

    & > div:last-child {
      width: 100%;
      padding: 20px;
    }
  }
`

const FindGroup = styled.div`
  margin: 22px 0 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  a {
    color: #858d95;
    font-size: var(--font-size-12);
    text-decoration: none;
  }

  a:hover {
    color: #f5811f;
  }
`

// const HorizontalRule = styled.span`
//   display: inline-block;
//   width: 1px;
//   height: 10px;
//   background-color: #777;
// `

const Title = styled.div`
  text-align: center;

  & h1 {
    margin: 0 0 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const LoginLogo = styled.div`
  width: 250px;
  height: 92px;
  background-image: url(${logo_inline_w});
  background-image: -webkit-image-set(url(${logo_inline_w}) 1x, url(${logo_inline_w}) 2x, url(${logo_inline_w}) 3x);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

const BlockLogo = styled.div`
  width: 128px;
  height: 58px;
  background-image: url(${logo});
  background-image: -webkit-image-set(url(${logo}) 1x, url(${logo}) 2x, url(${logo}) 3x);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

const LoginInputComponent = styled.div`
  width: min(100%, 390px);
  box-sizing: border-box;
  padding: 32px 34px 30px;    
  border-top: 7px solid #1c2027;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(31, 41, 55, 0.08);

  & > div:nth-child(2) {
    min-height: 34px;
    margin-bottom: 10px;
  }

  & > div:nth-child(2) a,
  & > div:nth-child(2) span {
    font-size: var(--font-size-12);
    text-decoration: none;
  }

  @media (max-width: 480px) {
    padding: 26px 22px;
  }
`

const InputGroup = styled.div`
  position: relative;
  margin: 18px 0 0;

  & input[type='text'], input[type='email'], input[type='password'] {
    width: 100%;
    height: 42px;
    box-sizing: border-box;
    padding: 0 13px;
    border: 1px solid #dfe3e7;
    background-color: #fff;
    border-radius: 7px;
    color: #30363d;
    font-family: inherit;
    font-size: var(--font-size-13);
    outline: 0;
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  & input:focus {
    border-color: #f5811f;
    box-shadow: 0 0 0 3px rgba(245,129,31,.1);
  }

  & input[type='checkbox'] + label {
    font-size: var(--font-size-12);
    color: #777
  }
`

const Button = styled.button`
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #f5811f;
  border-radius: 7px;
  color: #fff;
  background-color: #f5811f;
  font-family: inherit;
  font-size: var(--font-size-14);
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(245,129,31,.2);
  transition: background-color .15s ease, transform .15s ease;

  &:hover {
    background-color: #df7017;
    transform: translateY(-1px);
  }
`

const FindCorporationNo = styled.div`
  display: flex;
  align-items: center;
`


const ShowPassword = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 42px;
  height: 42px;
  background-image: url('/assets/images/login/hide.png');
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  cursor: pointer;
`

const LabelInline = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  color: #454c53;
  font-size: var(--font-size-13);
  font-weight: 700;
`
